import { Routes } from '@angular/router';

// Webapp ospiti raggiunta dal QR code dell'attività: l'indirizzo è /<id dell'annuncio>, poi le sezioni.
const sections: Routes = [
  { path: '', loadComponent: () => import('./pages/guest-home').then((m) => m.GuestHome) },
  { path: 'info', loadComponent: () => import('./pages/guest-info').then((m) => m.GuestInfoPage) },
  { path: 'info/:section', loadComponent: () => import('./pages/guest-info-section').then((m) => m.GuestInfoSection) },
  { path: 'menu', loadComponent: () => import('./pages/guest-menu').then((m) => m.GuestMenu) },
  { path: 'servizi', loadComponent: () => import('./pages/guest-services').then((m) => m.GuestServicesPage) },
  { path: 'attivita/:slug', loadComponent: () => import('./pages/guest-activity').then((m) => m.GuestActivityPage) },
  { path: 'lastminute', loadComponent: () => import('./pages/guest-offers').then((m) => m.GuestOffersPage) },
  { path: 'lastminute/:offerId', loadComponent: () => import('./pages/guest-offer-detail').then((m) => m.GuestOfferDetailPage), data: { kind: 'lastminute' } },
  { path: 'sconti/:offerId', loadComponent: () => import('./pages/guest-offer-detail').then((m) => m.GuestOfferDetailPage), data: { kind: 'coupons' } },
];

export const routes: Routes = [
  { path: '', pathMatch: 'full', loadComponent: () => import('./pages/guest-landing').then((m) => m.GuestLanding) },
  // percorso storico (/guest/<id>): stessi indirizzi, con o senza il prefisso
  { path: 'guest/:id', loadComponent: () => import('./pages/guest-shell').then((m) => m.GuestShell), children: sections },
  { path: ':id', loadComponent: () => import('./pages/guest-shell').then((m) => m.GuestShell), children: sections },
];
